import { AfterViewChecked, Component, ElementRef, HostBinding, Inject, Input, LOCALE_ID, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { Settings } from 'luxon';
import { MatIconRegistry, SafeResourceUrlWithIconOptions } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UtilsService } from 'src/services/utils.service';
import { TranslationService } from 'src/services/translation.service';
import { ChangeDetectorRef } from '@angular/core';
import { AuthService } from 'src/services/auth.service';
import { WebhooksService } from 'src/services/webhooks.service';
import { ApiUrlService } from 'src/services/api-url.service';
import { NotificationsService } from 'src/services/notifications.service';
import { getSiteName } from 'src/static-data/location-variables';
import { getUserDeviceDetails } from './shared/user-device-details';
import { DeviceInfoService } from 'src/services/device-info.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { IconRegistryService } from 'src/services/icon-registry.service';

@Component({
  selector: 'belender-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // Esta línea usa la variable del entorno para decidir la encapsulación
  encapsulation: environment.isWebComponent ? ViewEncapsulation.ShadowDom : ViewEncapsulation.Emulated,
})
export class AppComponent implements OnInit, AfterViewChecked {
  @HostBinding('style.position')
  get hostPosition(): string | null {
    return this.isWebComponent ? 'relative' : null;
  }

  @HostBinding('style.display')
  get hostDisplay(): string | null {
    return this.isWebComponent ? 'block' : null;
  }

  /// *** WebComponent Variables Start's *** ///
  // isWebComponent
  private _isWebComponent: boolean = false;
  @Input('is-web-component')
  set isWebComponent(val: boolean) {
    this._isWebComponent = val;
    console.log('isWebComponent received:', val);
  }
  get isWebComponent(): boolean {
    return this._isWebComponent;
  }
  // editableDates
  private _editableDates: boolean = false;
  @Input('editable-dates')
  set editableDates(val: boolean) {
    this._editableDates = val;
    console.log('editableDates received:', val);
  }
  get editableDates(): boolean {
    return this._editableDates;
  }
  // userId
  private _userId: string | null = null;
  @Input('user-id')
  set userID(val: string | null) {
    this._userId = val;
    console.log('userID received:', val);
  }
  public get userID(): string | null {
    return this._userId;
  }
  // requestId
  private _requestId: string | null = null;
  @Input('request-id')
  set requestId(val: string | null) {
    this._requestId = val;
    console.log('requestId received:', val);
  }
  get requestId(): string | null {
    return this._requestId;
  }
  // packageId
  private _packageId: string | null = null;
  @Input('package-id')
  set packageId(val: string | null) {
    this._packageId = val;
    console.log('packageId received:', val);
  }
  get packageId(): string | null {
    return this._packageId;
  }
  // flowType
  private _flowType: string | null = null;
  @Input('flow-type')
  set flowType(val: string | null) {
    this._flowType = val;
    console.log('flowType received:', val);
  }
  get flowType(): string | null {
    return this._flowType;
  }
  // documentNumber
  private _documentNumber: string | null = null;
  @Input('document-number')
  set documentNumber(val: string | null) {
    this._documentNumber = val;
    console.log('documentNumber received:', val);
  }
  get documentNumber(): string | null {
    return this._documentNumber;
  }
  // documentExpirationDate
  private _documentExpirationDate: string | null = null;
  @Input('document-expiration-date')
  set documentExpirationDate(val: string | null) {
    this._documentExpirationDate = val;
    console.log('documentExpirationDate received:', val);
  }
  get documentExpirationDate(): string | null {
    return this._documentExpirationDate;
  }
  // documentSupport
  private _documentSupport: string | null = null;
  @Input('document-support')
  set documentSupport(val: string | null) {
    this._documentSupport = val;
    console.log('documentSupport received:', val);
  }
  get documentSupport(): string | null {
    return this._documentSupport;
  }
  // phone
  private _phone: string | null = null;
  @Input()
  set phone(val: string | null) {
    this._phone = val;
    console.log('phone received:', val);
  }
  get phone(): string | null {
    return this._phone;
  }
  // email
  private _email: string | null = null;
  @Input()
  set email(val: string | null) {
    this._email = val;
    console.log('email received:', val);
  }
  get email(): string | null {
    return this._email;
  }
  // birthDate
  private _birthDate: string | null = null;
  @Input('birth-date')
  set birthDate(val: string | null) {
    this._birthDate = val;
    console.log('birthDate received:', val);
  }
  get birthDate(): string | null {
    return this._birthDate;
  }
  // urlPath
  private _urlPath: string | null = null;
  @Input('url-path')
  set urlPath(val: string | null) {
    this._urlPath = val;
    console.log('urlPath received:', val);
  }
  get urlPath(): string | null {
    return this._urlPath;
  }
  // apiUrl
  @Input('api-url')
  set apiUrl(val: string | null) {
    if (val) {
      this.apiUrlService.setBaseUrl(val);
    }
  }
  /// *** WebComponent Variables End's *** ///
  public loading: any = false;
  systemLoading = null;
  public financiadorID;
  isScaled = false;
  showScaleButton = true;

  funderConfigLoaded = false;
  funderStylesLoaded = false;
  userId: string;

  constructor(@Inject(LOCALE_ID) private localeId: string,
    private auth: AuthService,
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
    private notiService: NotificationsService,
    public utils: UtilsService,
    private cdRef:ChangeDetectorRef,
    public translateService: TranslationService,
    public webhooksService: WebhooksService,
    private router: Router,
    public deviceInfoService: DeviceInfoService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private iconService: IconRegistryService,
    private el: ElementRef,
    private apiUrlService: ApiUrlService

  ) {
    // Registrar CDN con Iconos de material para el webcomponent
    if (environment.isWebComponent) {
      this.iconService.initGlobalIcons();
    } else {
      this.renderer.addClass(this.el.nativeElement, 'belender-spa-wrapper');
    }

    this.systemLoading = 'Cargando sistema';
    this.auth.bindUserData().subscribe(d => {
      if(d) {
        this.financiadorID = d.funder_id;
        this.userID = d.user_id;
        this.bindFirebaseNotifications(d.funder_id);
        
      }
      this.systemLoading = null;
    })

    Settings.defaultLocale = this.localeId;


    this.matIconRegistry.addSvgIconResolver(
      (
        name: string,
        namespace: string
      ): SafeResourceUrl | SafeResourceUrlWithIconOptions | null => {
        switch (namespace) {
          case 'mat':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/material-design-icons/two-tone/${name}.svg`
            );

          case 'logo':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/logos/${name}.svg`
            );

          case 'flag':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/flags/${name}.svg`
            );
        }
      }
    );

  }

  ngOnInit(): void {
    console.log('AppComponent initialized with encapsulation:', 
      environment.isWebComponent ? 'ShadowDom' : 'Emulated');
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    getUserDeviceDetails().then((info) => {
      this.deviceInfoService.setDeviceInfo(info);
    });
    // set general zoom by params
    this.route.queryParams.subscribe(params => {
      if (params['scaled'] === 'true') {
        this.isScaled = true;
        this.deviceInfoService.setScaled(this.isScaled);
        this.updateScale();
      }
      
    });
    // hide zoom scale button if widget-boxed is false
    if (window.location.href.indexOf("widget-boxed") > -1 === false) {
      this.showScaleButton = false;
    }
    
  }

  ngAfterViewChecked() {
    this.utils.getLoading().subscribe(b => {
      this.loading = b;
      this.cdRef.detectChanges();
    });
    
    if (!environment.isWebComponent) {
      document.title = getSiteName();
    }
  }

  ngOnChanges() {
    if (this.isWebComponent) {
      this.setUrlPath(); // Simula navegación sin tocar la URL del navegador
    }
  }

  setUrlPath() {
    if (this.urlPath?.length == 0 || !this.urlPath) {
      const path = ['/widget', this.flowType, this.userID, this.packageId];
  
      const queryParams: any = {
        request_id: this.requestId,
        document_number: this.documentNumber,
        document_expiration_date: this.documentExpirationDate,
        document_support: this.documentSupport,
        phone: this.phone,
        email: this.email,
        birth_date: this.birthDate,
        editable_dates: this.editableDates ? 'true' : 'false'
        // Add more optional params here
      };
    
      // Remove empty or undefined query params
      Object.keys(queryParams).forEach(
        key => queryParams[key] == null && delete queryParams[key]
      );
    
      const urlTree = this.router.createUrlTree(path, { queryParams });
    
      this.urlPath = this.router.serializeUrl(urlTree);
    }
  
    this.router.navigateByUrl(this.urlPath, { skipLocationChange: true }); // Simula navegación sin tocar la URL padre del navegador
  }

  bindFirebaseNotifications(funderID) {
    this.notiService.bindFunderNotifications(funderID);
  }

  toggleScale() {
    this.isScaled = !this.isScaled;
    this.deviceInfoService.setScaled(this.isScaled);
    this.updateScale();
  }

  updateScale() {
    const scaler = document.body;
    if (scaler) {
      if (this.isScaled) {
        this.renderer.addClass(scaler, 'scaled');
      } else {
        this.renderer.removeClass(scaler, 'scaled');
      }
    }
  }

}
